import React, { useState, useEffect } from "react";
import "./style.scss";
// import CommonButton from "../commonButton";
import WarningIcon from "../../assets/images/timekeeping_icons/warning_icon.svg";
import moment from "moment";
// import Tooltip from "rc-tooltip";
// import "rc-tooltip/assets/bootstrap.css";
// import SortIcon from "../../assets/images/debit_report/expand_all.svg";

const PayrollTable = ({
  tableData,
  handleClick,
  //   handleExport,
  //   csvLoading,
  //   pdfLoading,
  //   sortOrder,
  //   setSortOrder,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [leastMonth, setLeastMonth] = useState(0);
  const [mostMonth, setMostMonth] = useState(0);
  useEffect(() => {
    if (tableData.length > 0) {
      const sortedTableData = tableData
        .map(({ start_date, end_date }) => ({
          startDate: moment(start_date).format("MMMM YYYY"),
          endDate: moment(end_date).format("MMMM YYYY"),
        }))
        .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
      setLeastMonth(sortedTableData[0].startDate);
      setMostMonth(sortedTableData[sortedTableData.length - 1].endDate);
    }
  }, [tableData]);
  // const handleSort = () => {
  //   setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  // };
  // const sortedTableData = tableData.sort((a, b) => {
  //   const dateA = moment(a.payment_date).format("YYYY-MM-DD");
  //   const dateB = moment(b.payment_date).format("YYYY-MM-DD");
  //   if (sortOrder === "asc") {
  //     return dateA.localeCompare(dateB);
  //   } else {
  //     return dateB.localeCompare(dateA);
  //   }
  // });
  const startIndex = currentPage * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const totalPages = Math.ceil(tableData.length / rowsPerPage);
  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(0);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
    // navigate(
    //   `?frequency=${selectTagValue.id}&page=${page}&status=${ptoStatus}`
    // );
  };

  return (
    <div className="payroll-listing-wrapper">
      <div className="payroll-list-title-wrapper">
        <h5>Payroll journal reports</h5>
        {tableData.length > 0 && (
          <p>
            {`The reports displayed below contain payroll journal records from the ${leastMonth} - ${mostMonth}`}
          </p>
        )}
      </div>
      <div className="pto-table-container">
        <div className="pto-table-scroll">
          {tableData && tableData.length > 0 ? (
            <table className="pto-table">
              <thead>
                <tr>
                  <th
                    style={{ width: "70%", textAlign: "left" }}
                    // onClick={handleSort}
                    className="pointer-cus"
                  >
                    Pay period
                    {/* <img src={SortIcon} alt="sort-icon" /> */}
                  </th>
                  <th style={{ width: "30%", textAlign: "left" }}>Report</th>
                </tr>
              </thead>
              <tbody>
                {tableData
                  .sort(
                    (a, b) => new Date(b.start_date) - new Date(a.start_date)
                  )
                  .slice(startIndex, endIndex)
                  .map((row, index) => (
                    <tr key={`row-${index}`}>
                      <td>{`${moment(row.start_date).format(
                        "MM/DD/YYYY"
                      )} - ${moment(row.end_date).format("MM/DD/YYYY")}`}</td>
                      <td>
                        <button onClick={() => handleClick(index)}>View</button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            <div className="no-data-text">
              <img src={WarningIcon} alt="warning" />
              <h5>No Data Found</h5>
            </div>
          )}
        </div>
        {tableData.length > 10 && (
          <div className="d-flex justify-content-between py-3 px-3">
            <div>
              <select value={rowsPerPage} onChange={handleRowsPerPageChange}>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={30}>30</option>
                <option value={50}>50</option>
              </select>
            </div>
            <div>
              {currentPage !== 0 && (
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  className="non-active-pagination-btn"
                >
                  &lt;
                </button>
              )}
              {Array.from({ length: totalPages }, (_, i) => i).map((page) => (
                <button
                  key={page}
                  disabled={currentPage === page}
                  onClick={() => handlePageChange(page)}
                  className={
                    currentPage === page
                      ? "active-pagination-btn "
                      : "non-active-pagination-btn"
                  }
                >
                  {page + 1}
                </button>
              ))}
              {currentPage !== totalPages - 1 && (
                <button
                  disabled={currentPage === totalPages - 1}
                  onClick={() => handlePageChange(currentPage + 1)}
                  className="non-active-pagination-btn"
                >
                  &gt;
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PayrollTable;
